import PropTypes from 'prop-types';
import React from 'react';

import ButtonIcon from '@glass/web/components/Button/ButtonIcon';
import Box from '@glass/web/components/base/Box';
import IconButton from '@glass/web/components/base/IconButton';
import ArrowBackIos from '@glass/web/components/base/icons/ArrowBackIos';
import { NONE } from '@glass/web/modules/theme/constants';
import makeStyles from '@glass/web/modules/theme/makeStyles';

import Button from '@glass/shared/components/Button/Button';

const useStyles = makeStyles()((theme) => ({
  button: {
    marginRight: theme.spacing(1),
  },
}));

function BuilderBackButton({ onClick }) {
  const { classes } = useStyles();
  return (
    <>
      <Button
        className={classes.button}
        color="inherit"
        sx={{ display: { xs: 'none', md: 'flex' } }}
        onClick={onClick}
      >
        <ButtonIcon fontSize={16} icon={ArrowBackIos} position={NONE} />
        Back
      </Button>
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <IconButton size="large" onClick={onClick}>
          <ArrowBackIos />
        </IconButton>
      </Box>
    </>
  );
}

BuilderBackButton.propTypes = {
  onClick: PropTypes.func,
};

export default React.memo(BuilderBackButton);
